export const dcrTableHeaderStyles = {
	header: {
		position: 'sticky',
		top: -1,
		zIndex: 1,

		height: 64,
		'& .MuiTableCell-root': {
			px: 1,
			py: 0.5,
			fontSize: 16,
			fontWeight: 700,
			borderBottom: '1px solid',
			borderColor: 'divider',
			backgroundColor: 'background.paper',
			verticalAlign: 'bottom',
			position: 'relative',
			userSelect: 'none',

			'&:hover .resizer': {
				opacity: 1
			}
		},
		'& .MuiTableCell-root:first-of-type': {
			fontSize: 20
		}
	}
};
